import Service, { inject as service } from '@ember/service';
import { enqueueTask } from 'ember-concurrency';

import { fetch, objectToQueryString } from 'later/utils/fetch';
import { objectSnakeToCamel } from 'shared/utils/object-methods';

import type ErrorsService from 'later/services/errors';

interface TodaysTopHashtagsRaw {
  top_hashtags: {
    explanations: string;
    top_hashtags: {
      Count: number;
      'Future Integral': number;
      Hashtag: string;
    }[];
  };
}

export interface TodaysTopHashtag {
  count: number | null;
  futureIntegral: number | null;
  name: string;
  explanation: string | null;
}

export default class SharedFutureInsightsService extends Service {
  @service declare errors: ErrorsService;

  loadTodaysTopHashtags = enqueueTask(async (groupId: string): Promise<TodaysTopHashtag[]> => {
    try {
      const endpoint = '/api/v2/social_listening/future_insights/top_hashtags';
      const params = { group_id: groupId };

      const requestUrl = `${endpoint}${objectToQueryString(params)}`;
      const response = await fetch(requestUrl);
      const todaysTopHashtags = this.sanitizeTodaysTopHashtags(response);

      return todaysTopHashtags;
    } catch (error) {
      this.errors.log('todays top hashtags list', error);
      throw error;
    }
  });

  sanitizeTodaysTopHashtags(data: TodaysTopHashtagsRaw): TodaysTopHashtag[] {
    let parsedExplanations;
    try {
      parsedExplanations = JSON.parse(data?.top_hashtags?.explanations);
    } catch (error) {
      throw new Error(error);
    }

    const remappedData = data.top_hashtags.top_hashtags.map((item) => ({
      count: item.Count,
      futureIntegral: item['Future Integral'],
      name: item.Hashtag ?? '-',
      explanation:
        parsedExplanations[item.Hashtag] && parsedExplanations[item.Hashtag] != 'N/A'
          ? parsedExplanations[item.Hashtag]
          : undefined
    }));

    return objectSnakeToCamel(remappedData);
  }
}

declare module '@ember/service' {
  interface Registry {
    'social-listening/future-insights': SharedFutureInsightsService;
  }
}
// lib / social - listening / addon / services / future - insights.ts;
